// API client de la Matriz de Buzones (backend mcp_django, auth Bearer JWT).
import { ensureFreshToken } from '@/lib/tokenRefresh';
import type { BuzonMatrix, MatrixApproval, EsquemaBuzon } from './types';

const DJANGO_PROXY = '/django-api';
const BASE = '/api/v1/admin/citizen-reports';

async function djangoFetch<T = any>(path: string, init?: RequestInit): Promise<T> {
  await ensureFreshToken();
  const jwt = localStorage.getItem('auth_token');
  if (!jwt) throw new Error('Sesión expirada. Inicia sesión nuevamente.');
  const res = await fetch(`${DJANGO_PROXY}${path}`, {
    ...init,
    headers: {
      Authorization: `Bearer ${jwt}`,
      ...(init?.body ? { 'Content-Type': 'application/json' } : {}),
      ...(init?.headers ?? {}),
    },
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    const detail = (err as any).detail || `Django ${res.status}: ${res.statusText}`;
    throw new Error(typeof detail === 'string' ? detail : JSON.stringify(detail));
  }
  return res.json();
}

export function getBuzonMatrix(): Promise<BuzonMatrix> {
  return djangoFetch<BuzonMatrix>(`${BASE}/buzon-matrix`);
}
export function approveBuzonMatrix(note: string): Promise<MatrixApproval> {
  return djangoFetch<MatrixApproval>(`${BASE}/buzon-matrix/approve`, {
    method: 'POST', body: JSON.stringify({ note }),
  });
}

/** Esquema vivo de buzones: dependencias ACTIVAS, su buzón real y las categorías que reciben. */
export function getBuzonEsquema(): Promise<EsquemaBuzon[]> {
  return djangoFetch<EsquemaBuzon[]>(`${BASE}/buzon-esquema`);
}
